import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
    TgBoxes2Module,
    TgButtons2Module,
    TgCardModule,
    TgCurrencyFormatterModule,
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconCameraModule,
    TgIconStopModule,
    TgIconBasicTickFramedModule,
    TgIconBasicTickModule,
    TgIconBasicCrossModule,
    TgIconEyeModule,
    TgInputModule,
    TgModalModule,
    TgSelectModule,
    TgRackModule,
    TgRadioModule,
    TgLists2Module,
    TgOverlayModule,
    TgCheckboxModule
} from '@trademe/tangram';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { PropertyPromoteSectionComponent } from './property-promote-section.component';
import { DraftValidationModule, TrademeCoreUiPipeModule } from '@classifieds-sell/shared';

@NgModule({
    imports: [
        CommonModule,
        DraftValidationModule,
        FormsModule,
        LayoutModule,
        RouterModule,
        TgBoxes2Module,
        TgButtons2Module,
        TgCardModule,
        TgCurrencyFormatterModule,
        TgGridModule,
        TgIconBasicArrowRightModule,
        TgIconBasicCrossModule,
        TgIconBasicTickFramedModule,
        TgIconBasicTickModule,
        TgIconCameraModule,
        TgIconEyeModule,
        TgIconStopModule,
        TgInputModule,
        TgLists2Module,
        TgModalModule,
        TgRackModule,
        TgRadioModule,
        TgSelectModule,
        TgOverlayModule,
        TrademeCoreUiPipeModule,
        TgCheckboxModule
    ],
    declarations: [PropertyPromoteSectionComponent],
    exports: [PropertyPromoteSectionComponent]
})
export class PropertyPromoteSectionModule { }
